import { Department } from '@interfaces/Department';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';
import { Resource } from '@interfaces/Resource';

export class DepartmentRow {
  public code: string;
  public description: string;

  public get responsible(): Resource | undefined {
    return this.departmentEstimate?.responsible;
  }
  public set responsible(v: Resource | undefined) {
    if (this.departmentEstimate) {
      this.departmentEstimate.responsible = v;
      this.departmentEstimate.responsibleId = v?.id;
    }
  }

  public constructor(public department: Department, public departmentEstimate?: DepartmentEstimate) {
    this.code = department.code;
    this.description = department.description;
  }
}
